<template>
  <nav>
    <router-link to="/">书籍</router-link> |
  </nav>
  <router-view></router-view>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding-left: 10px;
  font-size: 25px;
  position: fixed;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

#popup{
  position: absolute;
  min-width: 200px;
  border-radius: 10px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  border-color: gray;
  z-index: 999;
  top: 100px;
  max-height: calc(100% - 100px);
  display: block;
  overflow-y: scroll;
  font-size: 25px;
}
#content {
  text-align: left;
  position: absolute;
  height: calc(100% - 90px);
  margin-left: 5px;
  margin-right: 20px;
  width: calc(100% - 25px);;
  float: left;
  overflow-y:auto;
  top: 90px;
  font-size: 20px;
}
#menu {
  position: fixed;
  top: 50px;
  width: 100%;
  height: 30px;
  display: flex;
  font-size: 20px;
  color: blue;
  cursor: pointer;
}
#menu a{
  margin-left: 3px;
  margin-right: 3px;
}
#menu div{
  margin-left: 5px;
  margin-right: 5px;
}
.hlink{
  color: black;
  cursor: pointer;
}
</style>

<script lang="ts">
import { Vue } from 'vue-class-component';
export default class App extends Vue {
  mounted(): void {
    // 30天后过期
    this.$cookies.config('30d')
    document.title = "智慧人生";
  }
}
</script>
